import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PreferredStarWrapper, StarIcon } from './styles';

class PreferredStar extends Component {
  handleFavourites = () => {
    this.props.handleFavourites();
    if (process.env.REACT_APP_SITE !== 'corriere') {
      !this.props.isSelected && window.omniture && window.omniture.trkEventMc('Matchcenter preferiti match');
    }
  };

  render() {
    //const count = this.props.favouritesCounter;
    const { isSelected } = this.props;
    return (
      <PreferredStarWrapper >
        <StarIcon
          className="icon-matchcenter-star"
          onClick={this.handleFavourites}
          isSelected={isSelected}
        />
      </PreferredStarWrapper>
    );
  }
}

PreferredStar.propTypes = {
  handleFavourites: PropTypes.any,
  isSelected: PropTypes.any,
};

export default PreferredStar;
